
          <div
              class="d-flex align-items-center  mt-1 mb-2"
              style="padding-top:1.5px; padding-bottom:1.5px;width: fit-content;  height: 25px; margin-left:2em;background-color: #dbfbec;border-radius: 50rem;">
                <p class="mb-0 px-3 "
                style="font-family: 'Rubik'; font-size: 13px;font-weight: 400; "

                [style.color]="'#5bca90' || '#000000'"
                >
                     {{ result['vehicles'][0]['vehicle']['type'] }}
                </p>
            </div>

                      <p class="average m-0 d-flex align-items-center mt-2" style="padding-left: 2.5em">
                      <span class="d-flex align-items-center" *ngIf="result?.comments?.averageStars > 0">
                        <span style="display: flex; justify-content: center; align-items: center;background-color: black;border-radius: 50%;width: 17px;"
                        [ngStyle]="{'color': clientsSettingAppBooking?.clients_setting_global?.color_main_1}">{{result?.comments?.averageStars * 2}}</span>
                        <span *ngIf="result?.comments?.averageStars > 0" style="margin-left: 3px;font-style: italic">{{getCommentadjective(result?.comments?.averageStars)}}</span></span>
                      <span style="font-style: italic" [ngStyle]="{'color': result?.comments?.averageStars > 0 ? 'black' : '#bbbbbb',
                                        'margin-left': result?.comments?.averageStars > 0 ? '3px' : ''}">  {{result?.comments?.averageStars > 0 ? 'puntuación' : 'Sin puntuación'}}</span>
                    </p>

                    <div class="d-flex mt-3" style="gap: 1.25em; margin-left: 1em; padding-right: 1em">
                      <div class="w-100 d-flex flex-column justify-content-between" style="gap: 1em;">
                        <div class="d-flex align-items-center justify-content-end" style="gap: .25em;">
                          <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color:black;">{{ result['vehicles'][0]['vehicle']["maxPax"] }}</p>
                          <img src="../../../../../assets/icons/search-result/persona.svg" width="24px" height="24px" alt="">
                          <div class="d-flex flex-column">
                            <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;border-left: .5px solid #b9b9b9;">Personas</p>
                            <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;border-left: .5px solid #b9b9b9;">por
                              vehículo</p>
                          </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-end" style="gap: .25em;">
                          <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color:black;">{{ result['vehicles'][0]['vehicle']['bag']["maxBag"] }}</p>
                          <img src="../../../../../assets/icons/search-result/maleta.svg" width="24px" height="24px" alt="">
                          <div class="d-flex flex-column">
                            <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;border-left: .5px solid #b9b9b9;">Valijas
                            </p>
                            <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;border-left: .5px solid #b9b9b9;">por
                              vehículo</p>
                          </div>
                        </div>

                      </div>

                      <div class="w-100 d-flex flex-column justify-content-between" style="gap: 1em;">
                        <div class="d-flex align-items-center "
                          style="margin-top: -8px;gap: .25em; background-color: #f0f0f0; border-radius: 5px; padding: 5px 5px 5px 14px; border: .5px solid #dadada; width: 120px;">
                          <img src="../../../../../assets/icons/search-result/tiempo.svg" width="24px" height="24px" alt="">
                          <div class="d-flex flex-column">
                            <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;border-left: .5px solid #b9b9b9;">
                              {{roundTripTime}}
                            </p>
                            <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;border-left: .5px solid #b9b9b9;">Minutos
                            </p>
                          </div>

                          <div class="info-tool d-flex flex-column position-relative" *ngIf="result.vehicles[0].timing.return.returnTravelTime">
                          <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                          <span class="tooltip-info shadow-md">
                            <table class="table-info-tool">
                              <tr style="border-bottom: 1px solid #ececec;">
                                <th style="text-align: center">
                                  <div class="d-flex align-items-center justify-content-center" style="min-height: 45px;">
                                    <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;">Minutos</p>
                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <td class="d-flex flex-column justify-content-center align-items-center" style="height: 38px;">
                                  <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;">
                                    Ida:
                                    {{result.vehicles[0].timing.entry.entryTravelTime}}
                                    Minutos
                                  </p>

                                  <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;">
                                    Vuelta:
                                    {{result.vehicles[0].timing.return.returnTravelTime}}
                                    Minutos
                                  </p>
                                </td>
                              </tr>
                            </table>
                          </span>
                        </div>
                        </div>

                        <div class="d-flex align-items-center" style="gap: .25em;">
                          <p class="rubik-regular-13pt mb-0" style="font-weight: 500; color:black;">{{ result['vehicles'][0].vehicle.bag.numberHandbags ?
                            result['vehicles'][0].vehicle.bag.numberHandbags : 0 }}</p>
                          <img src="../../../../../assets/icons/search-result/carry.svg" width="26px" height="26px" alt="">
                          <div class="d-flex flex-column">
                            <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;border-left: .5px solid #b9b9b9;">Valijas de
                              mano
                            </p>
                            <p class="rubik-regular-12pt mb-0 pl-1" style="font-weight: 500; color:black;border-left: .5px solid #b9b9b9;">por
                              vehiculo</p>
                          </div>
                        </div>
                      </div>




                    </div>
